<script>
import VvBottomNavigation, {
  VV_BOTTOM_NAV_ROUTES
} from "@/components/crm/VvBottomNavigation.vue";
import VvHeader from "@/views/layout/VvHeader.vue";

export default {
  name: "VisionVentureLayout",
  components: {
    VvBottomNavigation,
    VvHeader
  },
  inject: {
    isInsideVisionVentureLayout: {
      default: false
    }
  },
  provide() {
    return {
      isInsideVisionVentureLayout: true
    };
  },
  computed: {
    normalizedRoutePath() {
      const path = this.$route.path || "";
      if (path.length > 1 && path.endsWith("/")) return path.slice(0, -1);
      return path;
    },
    showBottomNavigation() {
      return VV_BOTTOM_NAV_ROUTES.includes(this.normalizedRoutePath);
    },
    headerConfig() {
      // อ่านจาก route.meta — รองรับทั้ง visionVentureHeader (VV-specific)
      // และ fallback ไป standardV2Header เพื่อ reuse config เดิม
      if (
        Object.prototype.hasOwnProperty.call(
          this.$route.meta || {},
          "visionVentureHeader"
        )
      ) {
        return this.$route.meta.visionVentureHeader;
      }
      return (
        this.$route.meta?.standardV2Header || null
      );
    }
  },
  methods: {
    resolveHeaderTitle(headerConfig) {
      if (!headerConfig) return "";
      if (headerConfig.titleKey) return this.$t(headerConfig.titleKey);
      return headerConfig.title || "";
    },
    handleHeaderAction(action) {
      if (action.key === "back") {
        this.$router.back();
        return;
      }
      if (action.to) {
        this.$router.push(action.to);
        return;
      }
      this.emitter.emit("vv-header-action", {
        action: action.key,
        route: this.$route.name
      });
    }
  }
};
</script>

<template>
  <slot v-if="isInsideVisionVentureLayout" />
  <main
    v-else
    class="vision-venture-layout"
    data-test="vision-venture-layout"
  >
    <VvHeader
      v-if="headerConfig"
      :title="resolveHeaderTitle(headerConfig)"
      :show-back="headerConfig.showBack"
      :compact-back="headerConfig.compactBack"
      :variant="headerConfig.variant"
      :actions="headerConfig.actions"
      @action="handleHeaderAction"
    />
    <div
      :class="[
        'vision-venture-layout__content',
        {
          'vision-venture-layout__content--with-header': headerConfig,
          'vision-venture-layout__content--with-bottom-navigation':
            showBottomNavigation
        }
      ]"
      data-test="vision-venture-content"
    >
      <slot />
    </div>
    <VvBottomNavigation v-if="showBottomNavigation" />
  </main>
</template>

<style lang="scss" scoped>
.vision-venture-layout {
  min-height: 100dvh;
  background: var(--crm-vv-page-background);
  color: var(--text-color);
}

.vision-venture-layout__content {
  min-height: 100vh;
}

.vision-venture-layout__content--with-header {
  min-height: calc(100vh - 70px);
}

.vision-venture-layout__content--with-bottom-navigation {
  min-height: calc(100vh - 96px);
  padding-bottom: calc(96px + env(safe-area-inset-bottom));
}
</style>
